import { APP_CONFIG } from '../config/config';
import { apiFetch } from '../lib/api';

export function fetchSearchResults(request) {
    const type = request.type ? `&type=${request.type}` : '';
    const pageSize = request.pageSize ? `&pageSize=${request.pageSize}` : '';
    return apiFetch(
        `${APP_CONFIG.apiUrl}/v2/teams/search?query=${request.input}${type}${pageSize}`
    );
}
export function fuzzySearch(request, callback) {
    fetchSearchResults(request).then(callback);
}
